/**
 * @author       sarah.walloga@zumper.com (Sarah Walloga)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  Check.tsx
 */

import { useTheme } from '@emotion/react'

import { IconProps } from '../../types'

export const Check = ({ fill, size = 12, ...rest }: IconProps) => {
  const { colors } = useTheme()

  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 14 12"
      width={size * 1.16}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1 5.61538L4.69231 10.6923L13 1"
        stroke={fill ?? colors.text}
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}
